const config = {
  apiEndpoint() {
    let endpoint = '';

    if (process.env.REACT_APP_API_ENDPOINT) {
      endpoint = process.env.REACT_APP_API_ENDPOINT;
    } else {
      switch (process.env.NODE_ENV) {
        case 'ci':
          endpoint = 'https://ci-api.huvercraft.com/';
          break;
        case 'production':
          endpoint = 'https://api.huvercraft.com/';
          break;
        default:
          endpoint = 'http://localhost:8888/';
          break;
      }
    }

    return endpoint;
  },

  apiUrl(action) {
    let url = config.apiEndpoint();
    if (action) { url += action; }
    return url;
  },
};

module.exports = config;



// WEBPACK FOOTER //
// ./src/Configs/App.js